// Email-bootstrap redeem: trades the single-use emailed handle for an in-memory bootstrap token. Never persisted, never logged.

import { loginRedeemUrl } from 'services/auth/constants';

export type BootstrapErrorCode = 'invalid' | 'rate_limited' | 'network';

export type BootstrapResult =
  | { ok: true; token: string }
  | { ok: false; code: BootstrapErrorCode };

const REQUEST_TIMEOUT_MS = 15_000;

const classifyStatus = (status: number): BootstrapErrorCode => {
  if (status === 429) return 'rate_limited';
  if (status >= 500) return 'network';
  return 'invalid';
};

const readToken = async (response: Response): Promise<string | null> => {
  try {
    const body = await response.json();
    return typeof body?.token === 'string' && body.token !== '' ? body.token : null;
  } catch {
    return null;
  }
};

export const redeemBootstrap = async (handle: string): Promise<BootstrapResult> => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  try {
    const response = await fetch(loginRedeemUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ h: handle }),
      signal: controller.signal,
    });
    if (!response.ok) return { ok: false, code: classifyStatus(response.status) };
    const token = await readToken(response);
    // A 2xx without a token cannot be retried: the handle is single-use.
    return token ? { ok: true, token } : { ok: false, code: 'invalid' };
  } catch {
    return { ok: false, code: 'network' };
  } finally {
    clearTimeout(timer);
  }
};
